import React from 'react'
import classNames from 'classnames'
import useBreakpoint from '#src/hooks/useBreakpoint'
import useClickOutside from '#src/hooks/useClickOutside'
import addYears from 'date-fns/addYears'
import format from 'date-fns/format'
// @ts-ignore
import ScrollLock, { TouchScrollable } from 'react-scrolllock'
import CloseIcon from './close.svg'
import styles from './styles.css'

interface CategorySelectorSheetProps {
  onCategorySelected?: (categorySlug: string, displayName: string) => void
  onRequestClose?: () => void
  className?: string
  light?: boolean
}

const CategorySelectorSheet: React.SFC<CategorySelectorSheetProps> = ({
  onCategorySelected = () => {},
  onRequestClose = () => {},
  className,
  light
}) => {
  const isLargerThanSm = useBreakpoint('sm')

  const categorySheetRef = useClickOutside<HTMLDivElement>(() => {
    onRequestClose()
  })

  return (
    <ScrollLock isActive={!isLargerThanSm}>
      <div
        className={classNames(styles.categorySheetOverlay, className)}
        onClick={() => {
          onRequestClose()
        }}
      >
        <CloseIcon className={styles.closeIcon} />
        <TouchScrollable>
          <div
            className={classNames(styles.categorySheet, {
              [styles.categorySheetLight]: light
            })}
            onClick={e => e.stopPropagation()}
            ref={categorySheetRef}
          >
            <h3 className={styles.categorySheetTitle}>Pick a category to get started</h3>
            <ul className={styles.groupList}>
              {/* Sports */}
              <li className={styles.groupListItem}>
                <div className={styles.categoryListTitle}>SPORTS</div>
                <ul className={styles.categoryList}>
                  <li className={styles.categoryListItem}>
                    <a
                      onClick={() => onCategorySelected('skis', 'Skis')}
                      className={styles.categoryListItemLink}
                    >
                      Skis
                    </a>
                  </li>
                  <li className={styles.categoryListItem}>
                    <a
                      onClick={() => onCategorySelected('snowboards', 'Snowboards')}
                      className={styles.categoryListItemLink}
                    >
                      Snowboards
                    </a>
                  </li>
                  <li className={styles.categoryListItem}>
                    <a
                      onClick={() => onCategorySelected('golf', 'Golf')}
                      className={styles.categoryListItemLink}
                    >
                      Golf
                    </a>
                  </li>
                  <li className={styles.categoryListItem}>
                    <a
                      onClick={() => onCategorySelected('cycling', 'Cycling')}
                      className={styles.categoryListItemLink}
                    >
                      Cycling
                    </a>
                  </li>
                  <li className={styles.categoryListItem}>
                    <a
                      onClick={() => onCategorySelected('camping', 'Camping & Hiking')}
                      className={styles.categoryListItemLink}
                    >
                      Camping & Hiking
                    </a>
                  </li>
                </ul>
              </li>

              {/* Travel */}
              <li className={styles.groupListItem}>
                <div className={styles.categoryListTitle}>TRAVEL</div>
                <ul className={styles.categoryList}>
                  <li className={styles.categoryListItem}>
                    <a
                      onClick={() => onCategorySelected('charters', 'Yacht charters')}
                      className={styles.categoryListItemLink}
                    >
                      Yacht charters
                    </a>
                  </li>
                </ul>
              </li>

              {/* Coming Soon */}
              <li className={styles.groupListItem}>
                <div className={styles.categoryListTitleComingSoon}>
                  COMING SOON IN {format(addYears(new Date(), 1), 'YYYY')}
                </div>
                <ul className={styles.categoryList}>
                  <li className={styles.categoryListItemComingSoon}>Adventure travel</li>
                  <li className={styles.categoryListItemComingSoon}>Ski vacations</li>
                  <li className={styles.categoryListItemComingSoon}>Fly fishing</li>
                </ul>
              </li>
            </ul>
          </div>
        </TouchScrollable>
      </div>
    </ScrollLock>
  )
}

export default CategorySelectorSheet
